import React from 'react';
import PropTypes from 'prop-types';
import { PARTNER_OFFER_ADDRESS_LOOKUP } from 'client/site-modules/shared/constants/appraisal/appraisal';
import { useAppraisalTabsConfig } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/context/appraisal-tabs-context';
import { useAddressToVin } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/hooks/use-address-to-vin';
import {
  appraisalTabViewPropType,
  getResolvedAppraisalTabViewProps,
} from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/shared/appraisal-tab-view';

import { FindVinByAddressV2 } from './find-vin-by-address-v2';

export const AddressTab = ({ isLandingPage = true, view = null, ...restProps }) => {
  const { creativeId } = useAppraisalTabsConfig();
  const { onAddressVin } = useAddressToVin();
  const { isMobile } = getResolvedAppraisalTabViewProps({ view, ...restProps });

  return (
    <div className="address-tab">
      <FindVinByAddressV2
        {...restProps}
        creativeId={creativeId || PARTNER_OFFER_ADDRESS_LOOKUP}
        hasEscapeHatch={false}
        isAddressTab
        isLandingPage={isLandingPage}
        isMobile={isMobile}
        updateVinAndContinue={onAddressVin}
        {...(view ? { view } : {})}
      />
    </div>
  );
};

AddressTab.propTypes = {
  isLandingPage: PropTypes.bool,
  view: appraisalTabViewPropType,
};
